import CTLBillingTraceCell from "application/components/CTLBillingTraceCell";
import CTLBooleanCell from "application/components/CTLBooleanCell";
import { BillingReportMenu } from "globals/configuration/BillingReportMenu";

const Attributes = {
  enableAddButton: false,
  enableUpdateTableRecords: true,
  enableDownloadButton: true,
  enableAdvanceSearch: true,
  enableDownloadPdf: true,
  enableRefresh: true,
  modes: BillingReportMenu.map((item) => {
    return {
      id: item.key,
      name: item.name,
      iconName: item.icon,
      url: item.url,
      description: item.description,
      disabled: item.disabled,
      productionReady: item.productionReady,
    };
  }),
};

const operationURLS = {
  list: "/viewChannels/list/billing",
  pdfDownload: "/viewChannels/generateAndDownloadPdf",
  csvDownload: "/viewChannels/downloadCSV",
};

const getColumns = () => {
  return [
    {
      Header: "Caller Number",
      accessor: "callerIdNumber",
      displayInList: true,
      allowInForm: false,
      allowFilter: true,
      dataType: "string",
      dateTime: false,
      Cell: ({ value, row }) => <CTLBillingTraceCell value={value} row={row} />,
    },
    {
      Header: "Caller Name",
      accessor: "callerIdName",
      displayInList: true,
      allowInForm: true,
      allowFilter: false,
      dataType: "string",
      Cell: ({ value, row }) => <CTLBillingTraceCell value={value} row={row} />,
    },
    {
      Header: "did Number",
      accessor: "didNumber",
      displayInList: true,
      allowInForm: true,
      allowFilter: false,
      dataType: "integer",
      Cell: ({ value, row }) => <CTLBillingTraceCell value={value} row={row} />,
    },
    {
      Header: "dod Number",
      accessor: "dodNumber",
      displayInList: true,
      allowInForm: true,
      allowFilter: false,
      dataType: "string",
      Cell: ({ value, row }) => <CTLBillingTraceCell value={value} row={row} />,
    },
    {
      Header: "direction",
      accessor: "direction",
      displayInList: true,
      allowInForm: true,
      allowFilter: false,
      dataType: "string",
      Cell: ({ value, row }) => <CTLBillingTraceCell value={value} row={row} />,
    },
    {
      Header: "Destination Name",
      accessor: "destinationName",
      displayInList: true,
      allowFilter: false,
      dataType: "string",
      Cell: ({ value }) => <CTLBillingTraceCell value={value} />,
    },
    {
      Header: "Destination Number",
      accessor: "destinationNumber",
      displayInList: true,
      allowInForm: true,
      allowFilter: true,
      dataType: "string",
      Cell: ({ value, row }) => <CTLBillingTraceCell value={value} row={row} />,
    },
    {
      Header: "start Time",
      accessor: "startStamp",
      displayInList: true,
      allowInForm: true,
      allowFilter: true,
      dateTime: true,
      dataType: "date",
      Cell: ({ value, row }) => <CTLBillingTraceCell value={value} row={row} />,
    },
    {
      Header: "answer Time",
      accessor: "answerStamp",
      displayInList: true,
      allowInForm: true,
      allowFilter: true,
      dataType: "date",
      dateTime: true,
      Cell: ({ value, row }) => <CTLBillingTraceCell value={value} row={row} />,
    },
    {
      Header: "end Time",
      accessor: "endStamp",
      displayInList: true,
      allowInForm: true,
      allowFilter: true,
      dataType: "date",
      dateTime: true,
      Cell: ({ value, row }) => <CTLBillingTraceCell value={value} row={row} />,
    },
    {
      Header: "TalkTime",
      accessor: "billSec",
      displayInList: true,
      allowInForm: true,
      allowFilter: false,
      dataType: "integer",
      Cell: ({ value, row }) => <CTLBillingTraceCell value={value} row={row} />,
    },
    {
      Header: "Total BillSec",
      accessor: "totalBillSec",
      displayInList: false,
      allowInForm: false,
      allowFilter: false,
      dataType: "integer",
      Cell: ({ value, row }) => <CTLBillingTraceCell value={value} row={row} />,
    },
    {
      Header: "Total CallCost",
      accessor: "totalCallCost",
      displayInList: false,
      allowInForm: false,
      allowFilter: false,
      dataType: "integer",
      Cell: ({ value, row }) => <CTLBillingTraceCell value={value} row={row} />,
    },
    {
      Header: "Status",
      accessor: "status",
      displayInList: true,
      allowInForm: true,
      allowFilter: true,
      filterControlType: "select",
      dataType: "string",
      controlType: "select",
      options: {
        keyField: "keyField",
        keyDescription: "description",
        values: [
          { keyField: "answered", description: "answered" },
          { keyField: "unanswered", description: "unanswered" },
        ],
      },
      Cell: ({ value, row }) => <CTLBillingTraceCell value={value} row={row} />,
    },
    {
      Header: "Duration (HH:MM:SS)",
      accessor: "formattedDuration",
      displayInList: true,
      allowInForm: true,
      allowFilter: false,
      dataType: "integer",
      sortDisable: true,
      Cell: ({ value, row }) => <CTLBillingTraceCell value={value} row={row} />,
    },
    {
      Header: "call Type",
      accessor: "callType",
      displayInList: true,
      allowInForm: true,
      allowFilter: true,
      dataType: "string",
      filterControlType: "select",
      dataType: "string",
      controlType: "select",
      // options: {
      //   keyField: "callType",
      //   keyDescription: "callType",
      //   values: [],
      //   url: "/viewChannels/listAll",
      // },
      options: {
        keyField: "keyField",
        keyDescription: "description",
        values: [
          { keyField: "LOCAL", description: "LOCAL" },
          { keyField: "STD", description: "STD" },
          { keyField: "ISD", description: "ISD" },
        ],
      },
      Cell: ({ value, row }) => <CTLBillingTraceCell value={value} row={row} />,
    },
    {
      Header: "pulse",
      accessor: "pulse",
      displayInList: true,
      allowInForm: true,
      allowFilter: false,
      dataType: "integer",
      Cell: ({ value, row }) => <CTLBillingTraceCell value={value} row={row} />,
    },
    {
      Header: "call Cost",
      accessor: "callCost",
      displayInList: true,
      allowInForm: true,
      allowFilter: false,
      dataType: "integer",
      Cell: ({ value, row }) => <CTLBillingTraceCell value={value} row={row} />,
    },
    {
      Header: "billing Uuid",
      accessor: "billingUuid",
      displayInList: false,
      allowInForm: true,
      allowFilter: false,
      dataType: "string",
      Cell: ({ value, row }) => <CTLBillingTraceCell value={value} row={row} />,
    },
    {
      Header: "MOS",
      accessor: "mos",
      displayInList: true,
      allowFilter: false,
      dataType: "string",
      Cell: ({ value, row }) => <CTLBillingTraceCell value={value} row={row} />,
    },
    {
      Header: "Jitter Min Variance",
      accessor: "rtpJitterMinVariance",
      displayInList: true,
      allowFilter: false,
      dataType: "string",
      Cell: ({ value, row }) => <CTLBillingTraceCell value={value} row={row} />,
    },
    {
      Header: "Jitter Max Variance",
      accessor: "rtpJitterMaxVariance",
      displayInList: true,
      allowFilter: false,
      dataType: "string",
      Cell: ({ value, row }) => <CTLBillingTraceCell value={value} row={row} />,
    },

    {
      Header: "Jitter Loss Rate",
      accessor: "rtpJitterLossRate",
      displayInList: true,
      allowFilter: false,
      dataType: "string",
      Cell: ({ value, row }) => <CTLBillingTraceCell value={value} row={row} />,
    },

    ...(window?.enableTraceCall
      ? [
          {
            Header: "Call Trace",
            accessor: "callTrace",
            displayInList: true,
            filterControlType: "select",
            allowFilter: true,
            filterValue: "boolean",
            dataType: "boolean",
            Cell: ({ value, row }) => (
              <CTLBooleanCell value={value} row={row} />
            ),
            options: {
              keyField: "keyField",
              keyDescription: "description",
              values: [
                { keyField: "true", description: "True" },
                { keyField: "false", description: "False" },
              ],
            },
          },
        ]
      : []),
  ];
};

export { getColumns, Attributes, operationURLS };
